import request from '@/utils/request'

const exchange_rateApi = {
  exchange_rate_list: '/exchange_rate/',
  exchange_rate_create: '/exchange_rate/',
  exchange_rate_delete: '/exchange_rate/'
}

/**
 * 列表
 */
export function exchange_rate_list (parameter) {
  return request({
    url: exchange_rateApi.exchange_rate_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function exchange_rate_create (parameter) {
  return request({
    url: exchange_rateApi.exchange_rate_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 删除
 */
export function exchange_rate_delete (exchange_rate_id) {
  return request({
    url: exchange_rateApi.exchange_rate_delete + exchange_rate_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
